"use client";

import { useEffect, useState } from "react";

export function useScrollThreshold(threshold: number = 10) {
  const [passed, setPassed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setPassed(window.scrollY > threshold);
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return passed;
}